import * as STD from '@emersya/mpa-std-lib';
import CM       from '@emersya/mpa-components-manager-lib';

interface RootCondition {
	toSelect : string; // id of the child to select
};
type TRootCondition = CM.Condition.TCondition & RootCondition;
type TRootConditionSerialized = CM.Condition.TSerialized & RootCondition;

export interface IConditionComponentConfiguration extends CM.DOMComponent.IConfiguration {
	switches : TRootConditionSerialized[]; // The first switch that evaluate to true is used
	// When one of theses events are dispatched the evaluation is done again automatically but no switches will be evaluated before
	// If eval needed before event dispatch then you need to manually call evaluate
	// If no events given the eval be done on component play
	events? : {
		id : string;
		path : CM.Path.TPathRaw;
	}[];
	noEvaluationByDefault? : boolean;
};

export class ConditionComponent extends CM.DOMComponent<
	HTMLDivElement,
	ConditionComponent,
	IConditionComponentConfiguration
>
{
	static count = 0;
	component_DOM : HTMLDivElement;
	switches : TRootCondition[] = [];
	enabled : CM.Component<any, any> | null = null;

	private findActiveSwitch() {
		for (const _switch of this.switches) {
			if (!_switch.evaluate(this)) {
				continue;
			}
			return _switch;
		}
		return null;
	};

	override async component_start(startEvent : STD.events.Event<any, CM.Component<any, any>>) {
		await super.component_start(startEvent);
		// const evaluate = this.evaluate.bind(this);
		// if (this.configuration.events) {
		// 	for (let eventToListen of this.configuration.events) {
		// 		const c = CM.find(eventToListen.component.split('.'));
		// 		if (!c) throw STD.errors.user(RangeError, ``, {
		// 		});
		// 		c.addEventListener(eventToListen.id, evaluate, {
		// 			listener : this
		// 		});
		// 	}
		// }
		if (!this.component_configuration.noEvaluationByDefault) {
			await this.evaluate();
		}
	};

	async evaluate() {
		const activeSwitch = this.findActiveSwitch();
		if (!activeSwitch) {
			if (this.enabled) {
				await this.enabled.component_disable();
				this.enabled = null;
			}
			return;
		}
		const newEnabledComponent = this.component_findOuter([ activeSwitch.toSelect ]);
		if (!newEnabledComponent) {
			throw STD.errors.user('Component not found', { activeSwitch });
		}
		for (const s of this.switches) {
			if (s === activeSwitch) {
				continue;
			}
			const component = this.component_findOuter([ s.toSelect ]);
			if (!component || (component === newEnabledComponent)) {
				continue;
			}
			await component.component_disable();
		}
		this.enabled = newEnabledComponent;
		await this.enabled.component_enable();
		await this.component_dispatchVisibilityUpdateOnChilds();
		return (newEnabledComponent);
	};

	protected override component_childIsVisible(child : CM.DOMComponent<any, any, any>) {
		return (child === this.enabled);
	};

	constructor(
		descriptor : ConstructorParameters<typeof CM.Component>[0],
		configuration : IConditionComponentConfiguration
	)
	{
		super(descriptor, configuration);
		this.component_DOM = <HTMLDivElement> STD.DOM.factory({});
		for (const _switch of configuration.switches) {
			this.switches.push(
				CM.Condition.deserialize(_switch) as TRootCondition
			);
		}
	};
};
export namespace NS {
	export const Component = ConditionComponent;
	export type Component = ConditionComponent;
	export type Configuration = IConditionComponentConfiguration;
}
;
CM.declare({
	id :   'condition',
	type : ConditionComponent
});
